// frontend/src/services/notificationService.js
// Service for notification API calls

import api from './api';

/**
 * Get current user's notifications
 */
export const getNotifications = async (options = {}) => {
  const { type, isRead, limit = 50, offset = 0 } = options;
  const params = new URLSearchParams();

  if (type) params.append('type', type);
  if (isRead !== undefined) params.append('isRead', isRead);
  params.append('limit', limit);
  params.append('offset', offset);

  const response = await api.get(`/notifications?${params.toString()}`);
  return response.data;
};

/**
 * Get unread notification count
 */
export const getUnreadCount = async () => {
  const response = await api.get('/notifications/unread-count');
  return response.data;
};

/**
 * Mark a notification as read
 */
export const markAsRead = async (notificationId) => {
  const response = await api.put(`/notifications/${notificationId}/read`);
  return response.data;
};

/**
 * Mark all notifications as read
 */
export const markAllAsRead = async () => {
  const response = await api.put('/notifications/mark-all-read');
  return response.data;
};

/**
 * Delete a notification
 */
export const deleteNotification = async (notificationId) => {
  const response = await api.delete(`/notifications/${notificationId}`);
  return response.data;
};

/**
 * Delete all read notifications
 */
export const deleteReadNotifications = async () => {
  const response = await api.delete('/notifications');
  return response.data;
};

export default {
  getNotifications,
  getUnreadCount,
  markAsRead,
  markAllAsRead,
  deleteNotification,
  deleteReadNotifications
};
